module.exports = __webpack_public_path__ + "static/media/yellow_bg.b029c2ab.png";